/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { ReadSearchApiResponse, SearchScope } from 'lib-search-types';
import { convertChannelCasing } from 'lib-shared-api-utils';

/** Transforms the raw search response, applying scope-specific transformations. */
export function transformReadSearchResponse<
  TScope extends SearchScope,
  TEnriched extends boolean,
>(response: any, scope: TScope): ReadSearchApiResponse<TScope, TEnriched> {
  if (scope === 'conversations') {
    response.data.results.forEach(({ result }) => {
      result.initial_channel = convertChannelCasing(
        result.initial_channel as string,
        'snake',
      );
    });
  }

  return response;
}
